import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { solarRepairPages } from "@/data/solarRepairContent";

export const Route = createFileRoute("/services/solar-inverter-repair")({
  head: () => ({
    meta: [
      { title: "Solar Inverter Repair in Southern California - McKay Roofing & Solar" },
      { name: "description", content: "Solar inverter diagnostics and replacement across Southern California, backed by a manufacturer warranty." },
      { property: "og:title", content: "Solar Inverter Repair in Southern California - McKay Roofing & Solar" },
      { property: "og:description", content: "Solar inverter diagnostics and replacement across Southern California, backed by a manufacturer warranty." },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/solar-inverter-repair" }],
  }),
  component: () => <RoofingServicePage {...solarRepairPages["solar-inverter-repair"]} />,
});
